import Vue from 'vue'

import ActionButtons from '@/components/ActionButtons'
import LargeTextEditor from '@/components/LargeTextEditor'
import ConfirmationDialog from '@/components/ConfirmationDialog'
import CreatedDateToolTip from '@/components/CreatedDateToolTip'
import LastEditDetails from '@/components/LastEditDetails'
import UserDisplayName from '@/components/UserDisplayName'
import EntityReader from '@/components/EntityRead'
import EntityEditor from '@/components/EntityEditor'
import Forbidden from '@/components/Forbidden'
import MarkdownViewer from '@/components/MarkdownViewer'

Vue.component('action-buttons', ActionButtons)
Vue.component('large-text-editor', LargeTextEditor)
Vue.component('confirmation-dialog', ConfirmationDialog)
Vue.component('created-date', CreatedDateToolTip)
Vue.component('last-edit-details', LastEditDetails)
Vue.component('user-display-name', UserDisplayName)
Vue.component('entity-reader', EntityReader)
Vue.component('entity-editor', EntityEditor)
Vue.component('forbidden', Forbidden)
Vue.component('markdown-viewer', MarkdownViewer)
